import { i18n } from "i18next";

export function format(locale: i18n, number: number, fractionDigits: number = 2) {
    return number.toLocaleString(getLocale(locale), { maximumFractionDigits: fractionDigits })
}

function getLocale(locale: i18n) {
    if (locale.language.toLocaleLowerCase() === 'br') return 'pt-br';
    if (locale.language.toLocaleLowerCase() === 'us') return 'en-us';
}